/*
 * Harbour Roast — Collection Filter (redesign, variant A: left slide-in accordion drawer)
 * Keeps the proven engine: fetch products.json, then show/hide + reorder the theme's real
 * product cards (sold-out always sink to the bottom). Replaces the cramped bar with a
 * "Filters" button -> left drawer with accordion groups, live counts, and active chips.
 * Self-contained: injects its own CSS. Facet options are derived from live product data.
 */
(function () {
  'use strict';
  if (!window.location.pathname.startsWith('/collections/')) return;
  if (document.getElementById('hr-fx-toolbar')) return;

  var NAVY = '#1b2a4a', NAVY2 = '#16223c', TEAL = '#1a7a6d', TEAL2 = '#166459',
      CORAL = '#d4856a', CORAL2 = '#c06a4d', SAND1 = '#f7f3ed', SAND2 = '#ece5d9',
      SAND3 = '#ddd2be', BORDER = '#e4e0d9', GRAY5 = '#7d766a', GRAY6 = '#5a544a';

  var css = [
    '.hr-fx-toolbar{display:flex;align-items:center;justify-content:space-between;gap:16px;',
    'flex-wrap:wrap;max-width:1400px;margin:0 auto;padding:8px 24px 14px;font-family:var(--font-body--family,"Inter",sans-serif)}',
    '.hr-fx-count{font-size:14px;color:' + GRAY6 + ';letter-spacing:.01em}',
    '.hr-fx-count b{color:' + NAVY + ';font-weight:600}',
    '.hr-fx-right{display:flex;align-items:center;gap:10px}',
    '.hr-fx-select{position:relative}',
    '.hr-fx-select select{appearance:none;-webkit-appearance:none;font-family:inherit;font-size:13px;color:' + NAVY + ';',
    'background:#fff;border:1px solid ' + BORDER + ';border-radius:8px;padding:11px 36px 11px 14px;cursor:pointer;min-width:150px}',
    '.hr-fx-select::after{content:"\\25BE";position:absolute;right:13px;top:50%;transform:translateY(-50%);pointer-events:none;color:' + GRAY5 + ';font-size:11px}',
    '.hr-fx-filters{display:inline-flex;align-items:center;gap:9px;font-family:inherit;font-size:14px;font-weight:600;letter-spacing:.01em;',
    'background:' + NAVY + ';color:#fff;border:none;border-radius:8px;padding:0 18px;height:44px;cursor:pointer;transition:background .18s}',
    '.hr-fx-filters:hover{background:' + NAVY2 + '}',
    '.hr-fx-filters svg{width:15px;height:15px}',
    '.hr-fx-badge{background:' + CORAL + ';color:#22150f;border-radius:20px;font-weight:700;font-size:11px;line-height:1;padding:3px 8px}',
    '.hr-fx-chips{display:flex;gap:8px;flex-wrap:wrap;align-items:center;max-width:1400px;margin:0 auto;padding:0 24px 10px;',
    'font-family:var(--font-body--family,"Inter",sans-serif)}',
    '.hr-fx-chip{display:inline-flex;align-items:center;gap:8px;background:' + SAND1 + ';border:1px solid ' + SAND3 + ';',
    'color:' + NAVY + ';border-radius:999px;font-size:13px;padding:6px 8px 6px 14px}',
    '.hr-fx-chip button{cursor:pointer;width:17px;height:17px;display:flex;align-items:center;justify-content:center;',
    'background:' + NAVY + ';color:#fff;border:none;border-radius:50%;font-size:11px;line-height:1;padding:0}',
    '.hr-fx-clearall{font-size:13px;color:' + CORAL2 + ';cursor:pointer;text-decoration:underline;background:none;border:none;font-family:inherit}',
    '.hr-fx-scrim{position:fixed;inset:0;z-index:9998;background:rgba(15,18,25,.42);opacity:0;pointer-events:none;transition:opacity .3s}',
    '.hr-fx-scrim.on{opacity:1;pointer-events:auto}',
    '.hr-fx-drawer{position:fixed;z-index:9999;top:0;bottom:0;left:0;width:360px;max-width:88vw;background:#fff;',
    'box-shadow:0 24px 60px rgba(27,42,74,.22);display:flex;flex-direction:column;transform:translateX(-102%);',
    'transition:transform .34s cubic-bezier(.4,0,.2,1);font-family:var(--font-body--family,"Inter",sans-serif)}',
    '.hr-fx-drawer.on{transform:translateX(0)}',
    '.hr-fx-dh{display:flex;align-items:center;justify-content:space-between;padding:20px 22px;border-bottom:1px solid ' + BORDER + '}',
    '.hr-fx-dtitle{font-family:var(--font-heading--family,"Bebas Neue",sans-serif);font-size:24px;letter-spacing:.02em;color:' + NAVY + '}',
    '.hr-fx-x{font-size:26px;line-height:1;background:none;border:none;color:' + GRAY5 + ';cursor:pointer;padding:0 4px}',
    '.hr-fx-dbody{flex:1;overflow:auto}',
    '.hr-fx-grp-h{width:100%;display:flex;align-items:center;gap:10px;background:none;border:none;border-bottom:1px solid ' + SAND2 + ';',
    'padding:15px 22px;cursor:pointer;font-family:var(--font-heading--family,"Bebas Neue",sans-serif);font-size:18px;letter-spacing:.03em;color:' + NAVY + '}',
    '.hr-fx-grp-h .cnt{font-family:var(--font-body--family,"Inter",sans-serif);font-size:11px;font-weight:600;color:#fff;',
    'background:' + TEAL + ';border-radius:20px;padding:1px 8px;margin-left:auto}',
    '.hr-fx-grp-h .chev{color:' + GRAY5 + ';font-size:16px;width:14px;text-align:center;margin-left:4px}',
    '.hr-fx-opts{padding:6px 22px 16px}',
    '.hr-fx-optrow{width:100%;display:flex;align-items:center;gap:12px;padding:9px 0;cursor:pointer;font-size:14.5px;color:' + NAVY + ';',
    'background:none;border:none;text-align:left;font-family:inherit}',
    '.hr-fx-box{width:20px;height:20px;flex:none;border-radius:6px;border:2px solid ' + SAND3 + ';background:#fff;',
    'display:flex;align-items:center;justify-content:center;font-size:13px;color:#fff}',
    '.hr-fx-optrow.on .hr-fx-box{border-color:' + TEAL + ';background:' + TEAL + '}',
    '.hr-fx-optrow .oc{margin-left:auto;font-size:12px;color:' + GRAY5 + '}',
    '.hr-fx-dfoot{border-top:1px solid ' + BORDER + ';padding:16px 22px;display:flex;gap:10px}',
    '.hr-fx-clear{flex:1;background:none;border:1px solid ' + BORDER + ';border-radius:8px;padding:13px;cursor:pointer;',
    'font-family:var(--font-heading--family,"Bebas Neue",sans-serif);letter-spacing:.03em;font-size:16px;color:' + NAVY + '}',
    '.hr-fx-apply{flex:2;background:' + CORAL + ';color:#22150f;border:none;border-radius:8px;padding:13px;cursor:pointer;',
    'font-family:var(--font-heading--family,"Bebas Neue",sans-serif);letter-spacing:.03em;font-size:17px}',
    '.hr-fx-apply:hover{background:' + CORAL2 + ';color:#fff}',
    '.hr-fx-none{text-align:center;padding:60px 20px;font-family:var(--font-body--family,"Inter",sans-serif);color:' + GRAY5 + '}',
    '.hr-fx-none b{display:block;font-family:var(--font-heading--family,"Bebas Neue",sans-serif);font-size:22px;color:' + NAVY + ';margin-bottom:6px}',
    '.hr-fx-none button{margin-top:14px;background:' + NAVY + ';color:#fff;border:none;border-radius:8px;padding:10px 20px;cursor:pointer;',
    'font-family:var(--font-heading--family,"Bebas Neue",sans-serif);letter-spacing:.03em;font-size:15px}',
    '@media(max-width:749px){',
    '.hr-fx-toolbar{padding:6px 16px 12px}.hr-fx-chips{padding:0 16px 10px}',
    '.hr-fx-right{flex:1;justify-content:flex-end}.hr-fx-select select{min-width:0}',
    '.hr-fx-drawer{top:auto;left:0;right:0;bottom:0;width:auto;max-width:none;max-height:86vh;',
    'border-radius:20px 20px 0 0;transform:translateY(102%)}',
    '.hr-fx-drawer.on{transform:translateY(0)}}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var products = [], gridEl = null, cards = [];
  var GROUPS = [], sel = {}, expanded = {}, drawerOpen = false, sort = 'best-selling';

  var COUNTRIES = ['colombia', 'ethiopia', 'kenya', 'peru', 'burundi', 'el-salvador', 'brazil', 'india',
    'costa rica', 'guatemala', 'rwanda', 'honduras', 'ecuador', 'panama', 'mexico', 'tanzania', 'bolivia'];
  var PROCESS = [['washed', 'Washed'], ['natural', 'Natural'], ['honey', 'Honey'], ['anaerobic', 'Anaerobic'],
    ['co-ferment', 'Co-Ferment'], ['double-ferment', 'Double Ferment'], ['mixed-fermentation', 'Mixed Fermentation'],
    ['thermal-shock', 'Thermal Shock']];
  var NOTES = [
    ['Chocolatey', ['chocolat', 'cocoa', 'cacao', 'fudge']],
    ['Fruity', ['fruit', 'berry', 'cherry', 'peach', 'plum', 'currant', 'apple', 'watermelon', 'kiwi', 'guava',
      'starfruit', 'tropical', 'nectarine', 'mango', 'apricot', 'grape', 'raisin', 'fig', 'pineapple', 'red-plum', 'date']],
    ['Citrus', ['citrus', 'orange', 'lemon', 'lime', 'grapefruit', 'tangerine', 'marmalade', 'bergamot']],
    ['Floral', ['floral', 'flower', 'jasmine', 'rose', 'lavender', 'hibiscus', 'blossom']],
    ['Nutty', ['almond', 'hazelnut', 'peanut', 'pecan', 'walnut', 'marzipan', 'nutty']],
    ['Sweet / Caramel', ['caramel', 'sugar', 'honey', 'molasses', 'toffee', 'panela', 'cane', 'custard', 'syrup',
      'vanilla', 'butterscotch', 'maple']]
  ];
  var SORTS = [['best-selling', 'Featured'], ['price-asc', 'Price: Low to High'], ['price-desc', 'Price: High to Low'],
    ['title-asc', 'Name: A–Z'], ['title-desc', 'Name: Z–A'], ['created-desc', 'Newest'], ['roast-desc', 'Freshest Roast']];
  var PRICES = [['u25', '$25 & Under', function (p) { return p.price <= 25; }],
    ['2529', '$25 – $29', function (p) { return p.price > 25 && p.price < 30; }],
    ['3035', '$30 – $35', function (p) { return p.price >= 30 && p.price <= 35; }],
    ['o35', '$35+', function (p) { return p.price > 35; }]];
  var EQUIP_CATEGORIES = [['grinders', 'Grinders'], ['brewers', 'Brewers'], ['accessories', 'Accessories']];
  var OPEN_BY_DEFAULT = { roast: 1, roastdate: 1, type: 1, roaster: 1, category: 1 };
  var catMap = {}, itemNoun = 'coffee', itemNounPlural = 'coffees';

  function fetchProducts() {
    var handle = window.location.pathname.split('/').filter(Boolean).pop().split('?')[0];
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        products = d.products.map(function (p) {
          return {
            handle: p.handle, title: p.title, vendor: p.vendor,
            price: parseFloat(p.variants[0].price),
            available: p.variants.some(function (v) { return v.available; }),
            tags: p.tags.map(function (t) { return String(t).toLowerCase(); }),
            createdAt: p.created_at, roastDate: null,
            sizes: (p.variants || []).map(function (v) { return v.grams; }).filter(function (g) { return !!g; }).map(bagKey).filter(function (k, i, a) { return a.indexOf(k) === i; })
          };
        });
        try {
          var el = document.getElementById('hr-roast-dates');
          if (el) { var rd = JSON.parse(el.textContent); products.forEach(function (p) { p.roastDate = rd[p.handle] || null; }); }
        } catch (e) { }
      })
      .catch(function (e) { console.warn('HR filters: products fetch failed', e); });
  }

  function roastLevel(tags) {
    if (tags.some(function (t) { return t === 'light roast' || t === 'light-roast' || t === 'bright roast' || t === 'bright-roast'; })) return 'Light';
    if (tags.some(function (t) { return t === 'medium roast' || t === 'medium-roast'; })) return 'Medium';
    if (tags.some(function (t) { return t === 'dark roast' || t === 'dark-roast'; })) return 'Dark';
    return null;
  }
  function titleCase(s) { return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); }); }
  function fmtRoastDate(iso) { var d = new Date(iso + 'T00:00:00'); if (isNaN(d)) return iso; var m = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; return m[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }
  function bagKey(g) { var known = [250,283,312,340,454,500,907,2268]; for (var i=0;i<known.length;i++){ if (Math.abs(g-known[i])<=6) return known[i]; } return Math.round(g); }
  function bagLabel(g) { var m = {250:'250 g',283:'283 g (10 oz)',312:'312 g (11 oz)',340:'340 g (12 oz)',454:'454 g (1 lb)',500:'500 g',907:'907 g (2 lb)',2268:'2268 g (5 lb)'}; return m[g] || (g + ' g'); }
  function hasTag(p, tag) { return p.tags.indexOf(tag) !== -1; }
  function noteHit(p, keys) { return p.tags.some(function (t) { return keys.some(function (k) { return t.indexOf(k) !== -1; }); }); }
  function any(fn) { return products.some(fn); }
  function isEquip() { return any(function (p) { return hasTag(p, 'equipment'); }); }
  function fetchCats() {
    catMap = {};
    return Promise.all(EQUIP_CATEGORIES.map(function (c) {
      return fetch('/collections/' + c[0] + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (d) { d.products.forEach(function (p) { if (!catMap[p.handle]) catMap[p.handle] = c[1]; }); })
        .catch(function () { });
    }));
  }

  function buildGroups() {
    GROUPS = [];
    var equip = isEquip();
    itemNoun = equip ? 'item' : 'coffee'; itemNounPlural = equip ? 'items' : 'coffees';
    var roasts = ['Light', 'Medium', 'Dark'].filter(function (r) { return any(function (p) { return roastLevel(p.tags) === r; }); });
    if (roasts.length) GROUPS.push({ key: 'roast', label: 'Roast', options: roasts.map(function (r) { return { value: r, label: r, test: function (p) { return roastLevel(p.tags) === r; } }; }) });

    var roastDates = [];
    products.forEach(function (p) { if (p.roastDate && roastDates.indexOf(p.roastDate) === -1) roastDates.push(p.roastDate); });
    roastDates.sort();
    if (roastDates.length) GROUPS.push({ key: 'roastdate', label: 'Roast Date', options: roastDates.slice().reverse().map(function (d) { return { value: d, label: fmtRoastDate(d), test: (function (dd) { return function (p) { return p.roastDate === dd; }; })(d) }; }) });

    var types = [];
    if (any(function (p) { return hasTag(p, 'brew-espresso'); })) types.push('Espresso');
    if (any(function (p) { return hasTag(p, 'brew-filter'); })) types.push('Filter');
    if (types.length) GROUPS.push({ key: 'type', label: 'Brew Type', options: types.map(function (t) { return { value: t, label: t, test: function (p) { return hasTag(p, 'brew-' + t.toLowerCase()); } }; }) });

    var sizeKeys = [];
    products.forEach(function (p) { (p.sizes || []).forEach(function (k) { if (sizeKeys.indexOf(k) === -1) sizeKeys.push(k); }); });
    sizeKeys.sort(function (a, b) { return a - b; });
    if (!equip && sizeKeys.length > 1) GROUPS.push({ key: 'bagsize', label: 'Bag Size', options: sizeKeys.map(function (k) { return { value: String(k), label: bagLabel(k), test: (function (kk) { return function (p) { return (p.sizes || []).indexOf(kk) !== -1; }; })(k) }; }) });

    if (equip) {
      var catNames = EQUIP_CATEGORIES.map(function (c) { return c[1]; })
        .filter(function (name) { return any(function (p) { return catMap[p.handle] === name; }); });
      if (catNames.length > 1) GROUPS.push({ key: 'category', label: 'Category', options: catNames.map(function (name) { return { value: name, label: name, test: (function (nm) { return function (p) { return catMap[p.handle] === nm; }; })(name) }; }) });
    }

    var vendors = [];
    products.forEach(function (p) { if (p.vendor && vendors.indexOf(p.vendor) === -1) vendors.push(p.vendor); });
    vendors.sort();
    if (vendors.length) GROUPS.push({ key: 'roaster', label: equip ? 'Company' : 'Roaster', options: vendors.map(function (v) { return { value: v, label: v, test: function (p) { return p.vendor === v; } }; }) });

    var originOpts = COUNTRIES.filter(function (c) { return any(function (p) { return hasTag(p, c); }); })
      .map(function (c) { return { value: c, label: titleCase(c), test: (function (cc) { return function (p) { return hasTag(p, cc); }; })(c) }; });
    if (any(function (p) { return hasTag(p, 'blend'); })) originOpts.push({ value: 'blend', label: 'Blend', test: function (p) { return hasTag(p, 'blend'); } });
    if (originOpts.length) GROUPS.push({ key: 'origin', label: 'Origin', options: originOpts });

    var procOpts = PROCESS.filter(function (m) { return any(function (p) { return hasTag(p, m[0]); }); })
      .map(function (m) { return { value: m[0], label: m[1], test: (function (mm) { return function (p) { return hasTag(p, mm); }; })(m[0]) }; });
    if (procOpts.length) GROUPS.push({ key: 'process', label: 'Process', options: procOpts });

    var noteOpts = NOTES.filter(function (c) { return any(function (p) { return noteHit(p, c[1]); }); })
      .map(function (c) { return { value: c[0], label: c[0], test: (function (keys) { return function (p) { return noteHit(p, keys); }; })(c[1]) }; });
    if (noteOpts.length) GROUPS.push({ key: 'notes', label: 'Tasting Notes', options: noteOpts });

    var priceOpts = PRICES.filter(function (t) { return any(t[2]); }).map(function (t) { return { value: t[0], label: t[1], test: t[2] }; });
    if (priceOpts.length > 1) GROUPS.push({ key: 'price', label: 'Price', options: priceOpts });

    var availOpts = [];
    if (any(function (p) { return p.available; })) availOpts.push({ value: 'in', label: 'In Stock', test: function (p) { return p.available; } });
    if (any(function (p) { return !p.available; })) availOpts.push({ value: 'out', label: 'Sold Out', test: function (p) { return !p.available; } });
    if (availOpts.length > 1) GROUPS.push({ key: 'avail', label: 'Availability', options: availOpts });

    GROUPS.forEach(function (g) { if (!sel[g.key]) sel[g.key] = []; if (expanded[g.key] === undefined) expanded[g.key] = !!OPEN_BY_DEFAULT[g.key]; });
  }

  function passes(p) {
    return GROUPS.every(function (g) {
      var s = sel[g.key]; if (!s || !s.length) return true;
      return g.options.some(function (o) { return s.indexOf(o.value) !== -1 && o.test(p); });
    });
  }
  function countFor(o) { return products.filter(function (p) { return o.test(p); }).length; }
  function activeCount() { return GROUPS.reduce(function (a, g) { return a + (sel[g.key] ? sel[g.key].length : 0); }, 0); }
  function resultCount() { return products.filter(passes).length; }

  function cardHandle(card) { var a = card.querySelector('a[href*="/products/"]'); if (!a) return null; var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/); return m ? m[1] : null; }
  function prodOf(card) { if (card._hp !== undefined) return card._hp; var h = cardHandle(card); card._hp = h ? (products.filter(function (p) { return p.handle === h; })[0] || null) : null; return card._hp; }

  function apply() {
    if (!gridEl || !cards.length) return;
    var vis = [], hid = [];
    cards.forEach(function (c) { var p = prodOf(c); var show = p ? passes(p) : true; if (show) { c.style.display = ''; vis.push(c); } else { c.style.display = 'none'; hid.push(c); } });
    if (sort === 'best-selling') { vis.sort(function (a, b) { return products.indexOf(prodOf(a)) - products.indexOf(prodOf(b)); }); }
    else vis.sort(function (a, b) {
      var pa = prodOf(a), pb = prodOf(b); if (!pa || !pb) return 0;
      switch (sort) {
        case 'price-asc': return pa.price - pb.price;
        case 'price-desc': return pb.price - pa.price;
        case 'title-asc': return pa.title.localeCompare(pb.title);
        case 'title-desc': return pb.title.localeCompare(pa.title);
        case 'created-desc': return new Date(pb.createdAt) - new Date(pa.createdAt);
        case 'roast-desc': return new Date(pb.roastDate || 0) - new Date(pa.roastDate || 0);
        default: return 0;
      }
    });
    vis.sort(function (a, b) { var pa = prodOf(a), pb = prodOf(b); return ((pa && pa.available) ? 0 : 1) - ((pb && pb.available) ? 0 : 1); });
    var frag = document.createDocumentFragment();
    vis.forEach(function (c) { frag.appendChild(c); }); hid.forEach(function (c) { frag.appendChild(c); });
    gridEl.appendChild(frag);
    renderMeta(vis.length);
    var none = document.getElementById('hr-fx-none');
    if (!vis.length) {
      if (!none) {
        none = document.createElement('div'); none.id = 'hr-fx-none'; none.className = 'hr-fx-none';
        none.innerHTML = '<b>No ' + itemNounPlural + ' match</b><div>Try removing a filter or two.</div><button type="button" id="hr-fx-noneclear">Clear all filters</button>';
        gridEl.parentElement.insertBefore(none, gridEl.nextSibling);
        document.getElementById('hr-fx-noneclear').addEventListener('click', clearAll);
      }
    } else if (none) none.remove();
  }

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function renderMeta(n) {
    if (n === undefined) n = resultCount();
    var cEl = document.getElementById('hr-fx-count'); if (cEl) cEl.innerHTML = '<b>' + n + '</b> ' + (n === 1 ? itemNoun : itemNounPlural);
    var ac = activeCount();
    var badge = document.getElementById('hr-fx-badge'); if (badge) { badge.hidden = !ac; badge.textContent = ac; }
    var an = document.getElementById('hr-fx-applyn'); if (an) an.textContent = n + ' ' + (n === 1 ? itemNoun : itemNounPlural);
    var chipEl = document.getElementById('hr-fx-chips'); if (!chipEl) return;
    var chips = [];
    GROUPS.forEach(function (g, gi) { (sel[g.key] || []).forEach(function (v) { var o = g.options.filter(function (x) { return x.value === v; })[0]; if (o) chips.push('<span class="hr-fx-chip">' + esc(o.label) + '<button type="button" data-gi="' + gi + '" data-v="' + esc(v) + '" aria-label="Remove">\xD7</button></span>'); }); });
    chipEl.innerHTML = chips.length ? chips.join('') + '<button type="button" class="hr-fx-clearall" id="hr-fx-chipclear">Clear all</button>' : '';
    chipEl.style.display = chips.length ? 'flex' : 'none';
  }

  function renderDrawer() {
    var body = document.getElementById('hr-fx-dbody'); if (!body) return;
    body.innerHTML = GROUPS.map(function (g, gi) {
      var head = '<button type="button" class="hr-fx-grp-h" data-gi="' + gi + '">' + esc(g.label) +
        (sel[g.key] && sel[g.key].length ? '<span class="cnt">' + sel[g.key].length + '</span>' : '') +
        '<span class="chev">' + (expanded[g.key] ? '–' : '+') + '</span></button>';
      if (!expanded[g.key]) return head;
      var opts = g.options.map(function (o, oi) {
        var on = sel[g.key].indexOf(o.value) !== -1;
        return '<button type="button" class="hr-fx-optrow' + (on ? ' on' : '') + '" data-gi="' + gi + '" data-oi="' + oi + '">' +
          '<span class="hr-fx-box">' + (on ? '✓' : '') + '</span>' + esc(o.label) + '<span class="oc">' + countFor(o) + '</span></button>';
      }).join('');
      return head + '<div class="hr-fx-opts">' + opts + '</div>';
    }).join('');
  }

  function openDrawer() { drawerOpen = true; document.getElementById('hr-fx-scrim').classList.add('on'); document.getElementById('hr-fx-drawer').classList.add('on'); renderDrawer(); }
  function closeDrawer() { drawerOpen = false; document.getElementById('hr-fx-scrim').classList.remove('on'); document.getElementById('hr-fx-drawer').classList.remove('on'); }
  function toggleOpt(gi, oi) { var g = GROUPS[gi]; var v = g.options[oi].value; var s = sel[g.key]; var i = s.indexOf(v); if (i < 0) s.push(v); else s.splice(i, 1); renderDrawer(); apply(); }
  function removeChip(gi, v) { var g = GROUPS[gi]; var s = sel[g.key]; var i = s.indexOf(v); if (i > -1) s.splice(i, 1); if (drawerOpen) renderDrawer(); apply(); }
  function clearAll() { GROUPS.forEach(function (g) { sel[g.key] = []; }); if (drawerOpen) renderDrawer(); apply(); }

  function buildUI(section) {
    var toolbar = document.createElement('div');
    toolbar.className = 'hr-fx-toolbar'; toolbar.id = 'hr-fx-toolbar';
    toolbar.innerHTML =
      '<div class="hr-fx-count" id="hr-fx-count"></div>' +
      '<div class="hr-fx-right">' +
        '<div class="hr-fx-select"><select id="hr-fx-sort" aria-label="Sort">' +
          SORTS.map(function (s) { return '<option value="' + s[0] + '">' + s[1] + '</option>'; }).join('') +
        '</select></div>' +
        '<button type="button" class="hr-fx-filters" id="hr-fx-open">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="17" x2="14" y2="17"/></svg>' +
          'Filters<span class="hr-fx-badge" id="hr-fx-badge" hidden></span>' +
        '</button>' +
      '</div>';
    var chips = document.createElement('div'); chips.className = 'hr-fx-chips'; chips.id = 'hr-fx-chips'; chips.style.display = 'none';
    section.parentElement.insertBefore(toolbar, section);
    section.parentElement.insertBefore(chips, section);

    var scrim = document.createElement('div'); scrim.className = 'hr-fx-scrim'; scrim.id = 'hr-fx-scrim';
    var drawer = document.createElement('aside'); drawer.className = 'hr-fx-drawer'; drawer.id = 'hr-fx-drawer';
    drawer.innerHTML =
      '<div class="hr-fx-dh"><span class="hr-fx-dtitle">Filters</span><button type="button" class="hr-fx-x" id="hr-fx-close" aria-label="Close">\xD7</button></div>' +
      '<div class="hr-fx-dbody" id="hr-fx-dbody"></div>' +
      '<div class="hr-fx-dfoot"><button type="button" class="hr-fx-clear" id="hr-fx-clear">Clear all</button>' +
      '<button type="button" class="hr-fx-apply" id="hr-fx-apply">Show <span id="hr-fx-applyn"></span></button></div>';
    document.body.appendChild(scrim); document.body.appendChild(drawer);

    document.getElementById('hr-fx-sort').addEventListener('change', function (e) { sort = e.target.value; apply(); });
    document.getElementById('hr-fx-open').addEventListener('click', openDrawer);
    document.getElementById('hr-fx-close').addEventListener('click', closeDrawer);
    document.getElementById('hr-fx-apply').addEventListener('click', closeDrawer);
    document.getElementById('hr-fx-clear').addEventListener('click', clearAll);
    scrim.addEventListener('click', closeDrawer);
    document.getElementById('hr-fx-dbody').addEventListener('click', function (e) {
      var opt = e.target.closest('.hr-fx-optrow');
      if (opt) { toggleOpt(+opt.dataset.gi, +opt.dataset.oi); return; }
      var h = e.target.closest('.hr-fx-grp-h');
      if (h) { var g = GROUPS[+h.dataset.gi]; expanded[g.key] = !expanded[g.key]; renderDrawer(); }
    });
    chips.addEventListener('click', function (e) {
      if (e.target.id === 'hr-fx-chipclear') { clearAll(); return; }
      var b = e.target.closest('[data-gi]'); if (b) removeChip(+b.dataset.gi, b.dataset.v);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawerOpen) closeDrawer(); });
  }

  function findGrid(section) {
    var g = section.querySelector('[class*="resource-list--grid"]');
    if (g) return g;
    var first = section.querySelector('.product-card, .resource-list__item');
    if (first && first.parentElement) return first.parentElement;
    return null;
  }

  function init() {
    fetchProducts().then(function () {
      if (!products.length) return;
      var section = document.querySelector('.ui-test-product-list') || document.querySelector('[class*="main-collection"]');
      if (!section) return;
      gridEl = findGrid(section);
      if (!gridEl) return;
      cards = Array.prototype.slice.call(gridEl.children);
      if (!cards.length) return;
      var pre = isEquip() ? fetchCats() : Promise.resolve();
      pre.then(function () {
        buildGroups();
        buildUI(section);
        apply();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();